import ms from 'ms.macro'

// A request to get price don't need precise value for validTo
export const PRICE_QUOTE_VALID_TO_TIME = ms`30m`
